import React from "react";
import ContractCard from "@/components/atomics/contract-card";
import { GetgemsIcon } from "@/components/atomics/getgems-icon";
import { linkify } from "@/components/utils/linkify";
import { formatUTCDate } from "@/utils/common";
import { useNavigate } from "react-router-dom";
import { Attribute, CollectionStats } from "@/types/collection";

interface InfoSectionProps {
  stats: CollectionStats;
  collection: string;
  attributes?: Attribute[];
}
const InfoSection = ({ stats, collection, attributes }: InfoSectionProps) => {
  const navigate = useNavigate();

    const renderMetadata = () => {
    if (!attributes?.length) return null;

    return attributes.map((item, index) => (
      <div
        key={`metadata-${index}`}
        className="border-b-2 border-[#757575] border-solid flex justify-between pt-[5px]"
      >
        <p className="w-[50%] text-[13px] text-[#757575] font-spline-sans-mono">
          {item.trait_type}
        </p>
        <p className="w-[50%] text-[13px] text-[#757575] font-spline-sans-mono">
          {item.value}
        </p>
      </div>
    ));
  };


  return (
    <section className="px-[30px]">
      {stats.mint_time_limit !== 0 && (
        <div className="flex flex-col items-center justify-center">
          <span className="text-[20px] text-primary-red">!TIME LIMIT:</span>
          <span className="text-[20px]">
            {formatUTCDate(stats.mint_time_limit)}
          </span>
        </div>
      )}

      <ContractCard
        className="w-full pt-[10px] pb-[10px]"
        length={8}
        text="CONTRACT"
        address={stats.contract_address}
        onClick={() => {
          window.open(
            `https://tonviewer.com/${stats.contract_address}`,
            "_blank"
          );
        }}
      />
      <ContractCard
        className="w-full py-[10px]"
        length={8}
        text="OWNER"
        address={stats.owner_address}
        onClick={() => {
          navigate(`/owner/${stats.owner_address}`);
        }}
      />

      <div className="flex flex-col">
        <span className="text-[24px]">DESCRIPTION:</span>
        <p className="font-spline-sans-mono text-[13px] text-[#757575]  break-words whitespace-pre-wrap">
          {linkify(stats.description)}
        </p>
      </div>
      {renderMetadata()}
      <div className="pt-[20px] pb-[23px] flex pr-[1px] gap-[10px] items-center">
        <GetgemsIcon className="w-[24px] h-[24px]" />
        <a
          href={`https://getgems.io/collection/${collection}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[18px] underline"
        >
          WATCH ON GETGEMS
        </a>
      </div>
    </section>
  );
};

export default InfoSection;
